<div
  class="card-body"
  *ngIf="config && config.categoria && config.categoria.noticias && config.categoria.noticias.length > 0"
>
  <div
    *ngIf="config.mostrar_titulo == 1"
    class="card-title"
    [ngStyle]="{'color': getFontColor()}"
  >
    {{config.categoria.categoria}}
  </div>

  <swiper-container
    #swiperElement class="mySwiper swiper-container"
    slides-per-view="auto"
    [attr.slides-per-view]="(config.tipo_layout == 1 || config.tipo_layout == 2) ? '1.2' : 'auto'"
    autoplay-delay="{{config.idNoticiaCategoria == '-1' && noticiaList.length > 1 ? '3000' : 'false'}}"
    autoplay-disable-on-interaction="false"
    space-between="10"
    pagination="false"
  >
    <swiper-slide
      class="slide"
      *ngFor="let noticia of noticiaList"
      (click)="abrirNoticia(noticia)"
    >
      <div class="slide-content">
        <img [src]="noticia.imagemApp | image:''" />

        <div
          class="slider-infos"
          [ngStyle]="{'color': getFontColor()}"
          *ngIf="config.tipo_layout == 1"
        >
          <h6 class="m-0 titulo">{{noticia.titulo}}</h6>
          <p class="m-0 text-small subtitulo">{{noticia.subtitulo}}</p>
        </div>
      </div>
    </swiper-slide>

    <swiper-slide
      *ngIf="maximoNoticia && maximoNoticia.maximo && config.idNoticiaCategoria !== '-1'"
    >
      <div class="swiper-slide-full" (click)="abrirCategoria()">
        <div class="ver-todos" [ngStyle]="{'color': getFontColor()}">
          <div class="ver-todos-icon">
            <i class="fa-duotone fa-thin fa-newspaper icon"></i>
            <span class="ver-todos-span"> {{'VER TODOS' | translate}} </span>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
</div>
